import { render, staticRenderFns } from "./Progressbar.vue?vue&type=template&id=2a215802&scoped=true&"
import script from "./Progressbar.vue?vue&type=script&lang=js&"
export * from "./Progressbar.vue?vue&type=script&lang=js&"
import style0 from "./Progressbar.vue?vue&type=style&index=0&id=2a215802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a215802",
  null
  
)

export default component.exports